 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_CONTENTS from '@/components/xhtml/03_Contents'
 import XHTML04_PREFACE from '@/components/xhtml/04_Preface'
 import XHTML05_CHAPTER from '@/components/xhtml/05_Chapter'
 import XHTML06_CHAPTER from '@/components/xhtml/06_Chapter'
 import XHTML07_CHAPTER from '@/components/xhtml/07_Chapter'
 import XHTML08_CHAPTER from '@/components/xhtml/08_Chapter'
 import XHTML09_CHAPTER from '@/components/xhtml/09_Chapter'
 import XHTML10_CHAPTER from '@/components/xhtml/10_Chapter'
 import XHTML11_CHAPTER from '@/components/xhtml/11_Chapter'
 import XHTML12_CHAPTER from '@/components/xhtml/12_Chapter'
 import XHTML13_CHAPTER from '@/components/xhtml/13_Chapter'
 import XHTML0000_NOTES1 from '@/components/xhtml/0000_notes1'
 import XHTML14_FURTHER from '@/components/xhtml/14_Further'
 import XHTML15_LIST_OF from '@/components/xhtml/15_List_of'
 import XHTML16_INDEX from '@/components/xhtml/16_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/03_Contents",
 			"name" : "xhtml/03_Contents",
 			"component" : XHTML03_CONTENTS
 		},
 		{
 			"path" : "/xhtml/04_Preface",
 			"name" : "xhtml/04_Preface",
 			"component" : XHTML04_PREFACE
 		},
 		{
 			"path" : "/xhtml/05_Chapter",
 			"name" : "xhtml/05_Chapter",
 			"component" : XHTML05_CHAPTER
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js